import { ScoreFactor } from "@inrange/building-manager-api-client/models-site";
import React from "react";

import styled from "styled-components";
import { ScoreTooltipOrgContext } from "../utils/buildScoreTooltipText";
import AccountMenu from "./AccountMenu";
import BreadCrumbs, { BreadCrumb } from "./Breadcrumbs";
import SiteStatus from "./SiteStatus";

interface HeaderProps {
  crumbs: BreadCrumb[];
  userEmail: string;
  score?: number;
  scoreFactors?: ScoreFactor[];
  scoreOrgContext: ScoreTooltipOrgContext;
  siteStatus?: string;
  siteOperationalDate?: string | null;
}

const Header: React.FC<HeaderProps> = ({
  crumbs,
  userEmail,
  score,
  scoreFactors,
  scoreOrgContext,
  siteStatus,
  siteOperationalDate,
}) => {
  return (
    <HeaderContainer id={"layout-header"}>
      <BreadCrumbs crumbs={crumbs} />
      <SiteStatus
        score={score}
        scoreFactors={scoreFactors}
        scoreOrgContext={scoreOrgContext}
        siteStatus={siteStatus}
        siteOperationalDate={siteOperationalDate}
      />
      <AccountMenu userEmail={userEmail} />
    </HeaderContainer>
  );
};

export default Header;

const HeaderContainer = styled.div`
  background: white;
  display: flex;
  width: 100%;
  align-items: center;
  padding: 16px 20px;
  height: 72px;
`;
